// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._component-icon-svg[data-v-3d0a1653] {\n  width: 100%;\n  width: 20px;\n  height: 20px;\n}\n._component-icon-svg path[data-v-3d0a1653] {\n  fill: inherit;\n}\n", ""]);
// Exports
module.exports = exports;
